import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateWorkOrderPriceRationaleGql } from '../../workOrderQueries';

export const useUpdateWorkOrderPriceRationale = () => {
    const dispatch = useDispatch();

    const [resetUpdateData] = useResetStoreData({ requestId: 'uerUpdateWorkOrderPriceRationale' });

    const [, uerUpdateWorkOrderPriceRationaleStatus, , updateWorkOrderPriceRationale] = useRequest({
        requestId: 'uerUpdateWorkOrderPriceRationale',
        query: uerUpdateWorkOrderPriceRationaleGql,
        withEffect: false,
    });

    const updateWorkOrderPriceRationaleHandler = useCallback(
        (rationale: string, workOrderPriceId: number) => {
            dispatch(
                updateWorkOrderPriceRationale({
                    workOrderPriceId,
                    input: {
                        rationale,
                    },
                }),
            );
        },
        [updateWorkOrderPriceRationale, dispatch],
    );

    useEffect(
        () => () => {
            resetUpdateData(undefined);
        },
        [resetUpdateData],
    );

    return useMemo(
        () => ({
            uerUpdateWorkOrderPriceRationaleStatus,
            updateWorkOrderPriceRationaleHandler,
        }),
        [updateWorkOrderPriceRationaleHandler, uerUpdateWorkOrderPriceRationaleStatus],
    );
};
